import React from 'react';
import {COLORS, Image, Typography} from '@fupa/fupa-uikit';
import {Person} from '@mui/icons-material';
import styled from 'styled-components';
import {TransitionGroup} from 'react-transition-group';
import {Collapse} from '@mui/material';

const Component = styled.div`
  align-self: flex-end;
`;

const Name = styled(Typography)`
  &&& {
    color: ${COLORS.black};
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`;

const Description = styled.div`
  display: flex;
  line-height: 1rem;
  text-align: left;
  justify-content: center;
  flex-direction: column;
  height: 2rem;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid ${COLORS.white};
  background-color: ${COLORS.lightestGrey};
  color: ${COLORS.lightGrey};
  align-items: center;
`;

const LivetickerAuthor = ({author, children}) => {
  const avatar = author?.image ? (
    <Image entity='user' src={author.image} width={32} ratio='1:1' height={32} circle={true} />
  ) : (
    <IconWrapper>
      <Person color='inherit' />
    </IconWrapper>
  );

  const name = author?.firstName ?? author?.name ?? 'Unbekannt';

  const isTypingContent = children ? <Collapse>{children}</Collapse> : null;
  return (
    <Component>
      <Container>
        {avatar}
        <Description>
          <TransitionGroup>
            <Collapse>
              <Name variant='caption1'>{name}</Name>
            </Collapse>
            {isTypingContent}
          </TransitionGroup>
        </Description>
      </Container>
    </Component>
  );
};

export default LivetickerAuthor;
